import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { fetchIOChannelCallouts } from 'services/siteDirect/duck';
import { SiteDirectChannelDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import GenericSiteDirectModule from 'components/organisms/siteDirect/GenericSiteDirectModule';
import AudioModule from 'components/organisms/siteDirect/AudioModule';
import VideoModule from 'components/organisms/siteDirect/VideoModule';

class GenericSiteDirectContainer extends SiteDirectChannelDashboardComponent {
    constructor(props) {
        super(props, props.ioChannel);
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const ioChannel = this.getCurrentIOChannel();
        const payload = this.createPayload(entityId, ioChannel);
        this.props.fetchIOChannelCallouts(payload);
    }

    render() {
        const { ioChannel } = this.props;

        let TheModule;
        switch (ioChannel) {
        case 'audio':
            TheModule = AudioModule;
            break;
        case 'video':
            TheModule = VideoModule;
            break;
        case 'display':
        case 'mobile':
        case 'native':
        default:
            TheModule = GenericSiteDirectModule;
        }

        return (
            <TheModule
                channel={this.props.channel}
                ioChannel={this.props.ioChannel}
                entityMeta={this.props.entityMeta}
                entityObjective={this.props.entityObjective} />
        );
    }
}

const mapStateToProps = (state, props) => ({
    entityMeta: state.entities.meta,
    selectedTimeRange: state.config.selectedTimeRange,
    channel: state.siteDirect.channels[props.ioChannel],
    entityObjective: get(state, 'entities.meta.meta.programmaticObjective.global', 'ecpa')
});

export default connect(mapStateToProps, {
    fetchIOChannelCallouts,
})(GenericSiteDirectContainer);



// WEBPACK FOOTER //
// ./src/containers/dashboards/siteDirect/GenericSiteDirectContainer.js